const PolicyContent = () => {
  return (
    <main className="policy-page">
      <div className="policy-grid">
        <section className="policy-section">
          <h1 className="policy-title">Algemene voorwaarden</h1>

          <h2 className="policy-subtitle">1. Toepasselijkheid</h2>
          <p className="policy-text">
            Deze algemene voorwaarden zijn van toepassing op alle offertes, overeenkomsten en
            diensten van AirSolutions Belgium, gevestigd in België, gespecialiseerd in
            airconditioning en HVAC-oplossingen.
          </p>

          <h2 className="policy-subtitle">2. Diensten</h2>
          <p className="policy-text">
            AirSolutions Belgium levert installatie, onderhoud en herstelling van
            airconditioningsystemen voor residentiële en commerciële toepassingen.
          </p>

          <h2 className="policy-subtitle">3. Offertes en prijzen</h2>
          <p className="policy-text">
            Alle offertes zijn vrijblijvend tenzij anders vermeld. Prijzen zijn exclusief btw,
            tenzij expliciet anders aangegeven.
          </p>

          <h2 className="policy-subtitle">4. Betaling</h2>
          <p className="policy-text">
            Facturen dienen betaald te worden binnen de vermelde termijn. Bij laattijdige betaling
            kunnen interesten en administratieve kosten worden aangerekend.
          </p>

          <h2 className="policy-subtitle">5. Aansprakelijkheid</h2>
          <p className="policy-text">
            AirSolutions Belgium kan niet aansprakelijk worden gesteld voor indirecte schade,
            gevolgschade of schade door verkeerd gebruik van de installaties.
          </p>

          <h2 className="policy-subtitle">6. Toepasselijk recht</h2>
          <p className="policy-text">
            Op alle overeenkomsten is het Belgisch recht van toepassing. Geschillen vallen onder de
            bevoegdheid van de Belgische rechtbanken.
          </p>
        </section>

        <section className="policy-section">
          <h1 className="policy-title">Privacybeleid (GDPR)</h1>

          <h2 className="policy-subtitle">1. Verzameling van persoonsgegevens</h2>
          <p className="policy-text">
            AirSolutions Belgium verzamelt enkel persoonsgegevens die noodzakelijk zijn voor het
            uitvoeren van haar diensten, zoals naam, e-mailadres, telefoonnummer en adres.
          </p>

          <h2 className="policy-subtitle">2. Doeleinden van de verwerking</h2>
          <ul className="policy-list">
            <li>Het opstellen van offertes</li>
            <li>Het uitvoeren van installaties en onderhoud</li>
            <li>Communicatie met klanten</li>
            <li>Administratieve en wettelijke verplichtingen</li>
          </ul>

          <h2 className="policy-subtitle">3. Bewaartermijn</h2>
          <p className="policy-text">
            Persoonsgegevens worden niet langer bewaard dan strikt noodzakelijk voor het doel
            waarvoor ze werden verzameld, tenzij wettelijk anders vereist.
          </p>

          <h2 className="policy-subtitle">4. Delen van gegevens</h2>
          <p className="policy-text">
            Uw gegevens worden niet verkocht of gedeeld met derden, behalve wanneer dit noodzakelijk
            is voor de uitvoering van onze diensten of wettelijk verplicht is.
          </p>

          <h2 className="policy-subtitle">5. Rechten van de gebruiker</h2>
          <p className="policy-text">
            U heeft het recht om uw persoonsgegevens in te zien, te laten corrigeren of te laten
            verwijderen. U kan hiervoor contact opnemen via info@airsolutions.be.
          </p>

          <h2 className="policy-subtitle">6. Beveiliging</h2>
          <p className="policy-text">
            AirSolutions Belgium neemt passende technische en organisatorische maatregelen om uw
            persoonsgegevens te beschermen.
          </p>
        </section>

        <section className="policy-section">
          <h1 className="policy-title">Cookiebeleid</h1>

          <h2 className="policy-subtitle">1. Wat zijn cookies?</h2>
          <p className="policy-text">
            Cookies zijn kleine tekstbestanden die op uw apparaat worden opgeslagen wanneer u onze
            website bezoekt.
          </p>

          <h2 className="policy-subtitle">2. Welke cookies gebruiken wij?</h2>
          <ul className="policy-list">
            <li>Functionele cookies</li>
            <li>Analytische cookies</li>
          </ul>

          <h2 className="policy-subtitle">3. Cookies beheren</h2>
          <p className="policy-text">
            U kan cookies beheren of verwijderen via de instellingen van uw browser. Sommige
            onderdelen van de website kunnen minder goed functioneren zonder cookies.
          </p>
        </section>
      </div>
    </main>
  );
};

export default PolicyContent;
